export const open_climatic_settings = (device_id) => ({ type: 'CLIMATIC_SETTINGS__OPEN', device_id });
export const close_climatic_settings = () => ({ type: 'CLIMATIC_SETTINGS__CLOSE' });
export const set_service_mode = (service_mode_enabled) => ({
    type: 'CLIMATIC_SETTINGS__SET_SERVICE_MODE',
    service_mode_enabled,
});
export const set_config_service_mode = (service_mode) => async (dispatch, getState, { api }) => {
    const selected_id = getState().devices.selected_id;
    const devices = getState().devices;
    const device = devices.items.find((dev) => dev.id === selected_id) ?? devices.items[0];
    try {
        await api.update_device(device.id, {
            is_z3k_service_mode: service_mode,
        });
    }
    catch (e) {
        console.error(e);
    }
};
export const save_climatic_settings = (device_id, setter, reboot, reason) => async (dispatch, getState, { api }) => {
    dispatch({ type: 'CLIMATIC_SETTINGS__SAVE__REQUEST', device_id });
    const { z3k_config, ...rest } = setter;
    // console.log(setter);
    const commands = [];
    if (reboot)
        commands.push({
            object_id: null,
            command_name: 'RestartDevice',
            command_args: null,
        });
    try {
        await Promise.all([
            api.update_device(device_id, rest),
            api.save_z3k_config(device_id, z3k_config, commands, reason),
        ]);
        dispatch({ type: 'CLIMATIC_SETTINGS__SAVE__OK', device_id });
    }
    catch ({ json }) {
        dispatch({
            type: 'CLIMATIC_SETTINGS__SAVE__FAIL',
            error: json?.error_ui ?? 'Не удалось сохранить настройки',
        });
    }
};
export const clear_climatic_dialog_error = () => ({
    type: 'CLIMATIC_SETTINGS__CLEAR_ERROR',
});
const initial = {
    open: false,
    service_mode: false,
    device_id: null,
    loading: false,
    error: null,
};
export function reducer(state = initial, action) {
    switch (action.type) {
        case 'CLIMATIC_SETTINGS__OPEN':
            return { ...state, open: true, device_id: action.device_id };
        case 'CLIMATIC_SETTINGS__CLOSE':
            return { ...state, open: false };
        case 'CLIMATIC_SETTINGS__SET_SERVICE_MODE':
            return { ...state, service_mode: action.service_mode_enabled };
        case 'CLIMATIC_SETTINGS__SAVE__REQUEST':
            return { ...state, loading: true };
        case 'CLIMATIC_SETTINGS__SAVE__OK':
            return { ...state, loading: false };
        case 'CLIMATIC_SETTINGS__SAVE__FAIL':
            return { ...state, loading: false, error: action.error };
        case 'CLIMATIC_SETTINGS__CLEAR_ERROR':
            return { ...state, error: null };
        default:
            return state;
    }
}
